import React, { useState } from 'react'
import { RoleSelect } from '@ui'
import { ISelection } from '@hooks/useSelection'
import api, { Role } from '@api'
import { useUser } from '@hooks'
import track from '@track'
import Event from '@track/Event'
import { Toaster } from '@ui'
import { pluralize } from '@utils'

interface UpdateRoleButtonProps {
  disabled: boolean
  selection: ISelection
  reload: () => void
}

export default function UpdateRoleButton({ selection, disabled, reload }: UpdateRoleButtonProps) {
  const [loading, setLoading] = useState(false)
  const { user } = useUser()
  if (!user) return null
  const employeeId = user.employee.id

  const onRoleChange = async (role: Role) => {
    if (role === null) return
    // Filter out current user's id if selected
    const ids = Object.keys(selection.items).filter((id) => id !== employeeId)
    if (ids.length) {
      setLoading(true)
      try {
        await api.employee.batchUpdateRole({
          ids,
          role,
        })
        Toaster.success({
          message: `Role${pluralize(ids.length)} updated`,
        })
        setLoading(false)
        reload()
        track.employees({
          eventName: Event.BATCH_ACTION,
          props: {
            actionName: 'Update Role',
            actionValue: role,
            batchCount: selection.count,
          },
        })
      } catch (error: any) {
        setLoading(false)
        Toaster.fail({
          message: error.message,
        })
      }
    }
  }

  return (
    <RoleSelect
      disabled={disabled}
      value={null}
      onChange={(role) => {
        if (!role) return
        onRoleChange(role)
      }}
      btnText="Update Role"
      buttonProps={{ loading, 'data-button': 'update_role' }}
    />
  )
}
